// frontend/src/components/Articles/ArticleCard.js
import React from 'react';
import { Link } from 'react-router-dom';
import { formatDistanceToNow } from 'date-fns';
import { FiBookmark, FiShare2, FiEye } from 'react-icons/fi';

const PLACEHOLDER_IMG = 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" width="800" height="600"><rect width="100%" height="100%" fill="#e5e7eb"/><text x="50%" y="50%" text-anchor="middle" fill="#6b7280" font-family="Inter, Arial, sans-serif" font-size="24">AI News</text></svg>');

export default function ArticleCard({ article, variant = 'vertical' }) {
  const isHorizontal = variant === 'horizontal';
  
  if (isHorizontal) {
    return (
      <div className="group bg-white rounded-lg overflow-hidden shadow-sm hover:shadow-md transition-shadow duration-300">
        <Link to={`/article/${article.id}`}>
          <div className="flex flex-col md:flex-row">
            <div className="md:w-1/3 h-48 md:h-auto relative overflow-hidden">
              <img
                src={article.image_url || PLACEHOLDER_IMG}
                alt={article.title}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                onError={(e) => { e.currentTarget.src = PLACEHOLDER_IMG; }}
              />
              <div className="absolute top-4 left-4">
                <span className="px-2 py-1 text-xs font-semibold text-white rounded-full bg-blue-600">
                  {typeof article.category === 'string' ? article.category : (article.category?.name || 'General')}
                </span>
              </div>
            </div>
            <div className="flex-1 p-6">
              <div className="flex items-center text-sm text-gray-500 mb-3">
                <span>{article.source}</span>
                <span className="mx-2">•</span>
                <span>
                  {formatDistanceToNow(new Date(article.published_date), {
                    addSuffix: true,
                  })}
                </span>
              </div>
              <h3 className="text-xl font-bold text-gray-900 group-hover:text-blue-600 transition-colors mb-3">
                {article.title}
              </h3>
              <p className="text-gray-600 line-clamp-2 mb-4">{article.summary}</p>
              <div className="flex items-center text-sm text-gray-500 space-x-4">
                <div className="flex items-center">
                  <FiEye className="mr-1" />
                  <span>{article.views}</span>
                </div>
                <button className="flex items-center hover:text-blue-600">
                  <FiBookmark className="mr-1" />
                  <span>Save</span>
                </button>
                <button className="flex items-center hover:text-blue-600">
                  <FiShare2 className="mr-1" />
                  <span>Share</span>
                </button>
              </div>
            </div>
          </div>
        </Link>
      </div>
    );
  }
  
  // Vertical card variant (for grids)
  return (
    <div className="group bg-white rounded-lg overflow-hidden shadow-sm hover:shadow-lg transition-all duration-300">
      <Link to={`/article/${article.id}`}>
        <div className="relative h-48 overflow-hidden">
          <img
            src={article.image_url || PLACEHOLDER_IMG}
            alt={article.title}
            className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
            onError={(e) => { e.currentTarget.src = PLACEHOLDER_IMG; }}
          />
          <div className="absolute top-4 left-4">
            <span className="px-2 py-1 text-xs font-semibold text-white rounded-full bg-blue-600">
              {typeof article.category === 'string' ? article.category : (article.category?.name || 'General')}
            </span>
          </div>
        </div>
        <div className="p-4">
          <div className="flex items-center text-xs text-gray-500 mb-2">
            <span>{article.source}</span>
            <span className="mx-2">•</span>
            <span>
              {formatDistanceToNow(new Date(article.published_date), {
                addSuffix: true,
              })}
            </span>
          </div>
          <h3 className="font-bold text-gray-900 group-hover:text-blue-600 transition-colors line-clamp-2 mb-2">
            {article.title}
          </h3>
          <p className="text-gray-600 text-sm line-clamp-2">{article.summary}</p>
        </div>
      </Link>
    </div>
  );
}
